import React, { Component } from 'react'
import { FormControl, FormControlLabel, Checkbox } from '@mui/material'
import SelectRC, { Option } from 'rc-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class DisplayItemTextSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            validators:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.validators
                    ? this.props.item.settings.validators
                    : [],
            phone_number:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.phone_number
                    ? this.props.item.settings.phone_number
                    : null,
            company_lookup:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.company_lookup
                    ? this.props.item.settings.company_lookup
                    : null,
            company_key:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.company_key
                    ? this.props.item.settings.company_key
                    : null,
        }
        this.onChangeValidators = this.onChangeValidators.bind(this)
    }

    onChangeValidators(options) {
        let validators = []
        if (options) {
            options.forEach((item) => {
                validators.push(item.value)
            })
        }

        this.setState({ validators: validators })
        this.props.onChange('validators', validators)
    }

    onChangeCompanyItem(option) {
        this.setState({ company_key: option.value })
        this.props.onChange('company_key', option.value)
    }

    render() {
        const kedo = this.props.kedo
        const validatorOptions = [
            { value: 'BSN', label: kedo.t('BSN') },
            { value: 'IBAN', label: kedo.t('IBAN') },
            { value: 'UniqueValue', label: kedo.t('UniqueValue') },
        ]
        const companyKeyOptions = [
            { value: 'kvkNummer', label: kedo.t('kvkNummer') },
            { value: 'straatnaam', label: kedo.t('straatnaam') },
            { value: 'vestigingsnummer', label: kedo.t('vestigingsnummer') },
            { value: 'postcode', label: kedo.t('postcode') },
            { value: 'plaats', label: kedo.t('plaats') },
            { value: 'location', label: kedo.t('location') },
            { value: 'huisnummer', label: kedo.t('huisnummer') },
        ]

        let selected = []

        validatorOptions.forEach((item) => {
            if (
                this.state.validators &&
                Array.isArray(this.state.validators) &&
                this.state.validators.includes(item.value)
            ) {
                selected.push(item)
            }
        })

        const filteredOptions = validatorOptions.filter(
            (option) =>
                !selected.some((selected) => selected.value === option.value)
        )

        return (
            <div>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {this.props.kedo.t('Validators')}
                    </FormInputLabel>
                    <SelectRC
                        className="w-100 custom-select-react"
                        id={`${this.props.item.id}-text-settings`}
                        mode="multiple"
                        allowClear
                        disabled={this.props.disabled}
                        onChange={(selectedItems) => {
                            const selectedOptions = selectedItems.map(
                                (selectedItem) =>
                                    validatorOptions.find(
                                        (option) =>
                                            option.value === selectedItem.value
                                    )
                            )
                            this.onChangeValidators(selectedOptions)
                        }}
                        suffixIcon={<FontAwesomeIcon icon={faChevronDown} />}
                        placeholder={this.props.kedo.t('Choose an option')}
                        value={selected.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))}
                        labelInValue
                        notFoundContent={this.props.kedo.t('No items found')}
                    >
                        {filteredOptions.map((option) => (
                            <Option key={option.id} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </SelectRC>
                </FormControl>
                <FormControl fullWidth margin="dense">
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.phone_number === true}
                                onChange={(e) => {
                                    this.setState({
                                        phone_number: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'phone_number',
                                        e.target.checked
                                    )
                                }}
                                name="phone_number"
                                disabled={this.props.disabled}
                            />
                        }
                        label={kedo.t('Phone number')}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.company_lookup === true}
                                onChange={(e) => {
                                    this.setState({
                                        company_lookup: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'company_lookup',
                                        e.target.checked
                                    )
                                }}
                                name="company_lookup"
                                disabled={this.props.disabled}
                            />
                        }
                        label={kedo.t('Company lookup')}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                </FormControl>

                {this.state.company_lookup && (
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {this.props.kedo.t('Company key')}
                        </FormInputLabel>
                        <SelectRC
                            defaultValue={'kvkNummer'}
                            className="w-100 custom-select-react"
                            id={`${this.props.item.id}-company-keys`}
                            mode="default"
                            allowClear
                            disabled={this.props.disabled}
                            onChange={(selectedItems) => {
                                this.onChangeCompanyItem(selectedItems)
                            }}
                            suffixIcon={
                                <FontAwesomeIcon icon={faChevronDown} />
                            }
                            placeholder={this.props.kedo.t('Choose an option')}
                            value={companyKeyOptions.find(
                                (key) => key == this.setState.company_key
                            )}
                            labelInValue
                            notFoundContent={this.props.kedo.t(
                                'No items found'
                            )}
                        >
                            {companyKeyOptions.map((option) => (
                                <Option key={option.id} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </SelectRC>
                    </FormControl>
                )}
            </div>
        )
    }
}

export default DisplayItemTextSettings
